// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueWait from 'vue-wait'
import VueSession from 'vue-session'
import VueMask from 'v-mask'
import BootstrapVue from 'bootstrap-vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import uaparser from 'ua-parser-js'
import VCalendar from 'v-calendar'

import App from './App'
import router from './router'
import AuthMw from './middlewares/auth.mw'
import LoaderMw from './middlewares/loader.mw'
import Timetrack from './timetrack'

import _ from 'lodash'
import moment from 'moment'
import numeral from 'numeral'

import 'moment/locale/pt-br'
import 'numeral/locales/pt-br'

import DateFilter from './filters/date.filter'
import CurrencyFilter from './filters/currency.filter'
import NumberFilter from './filters/number.filter'
import SecToHmsFilter from './filters/secToHms.filter'
import OrderStatusFilter from './filters/orderStatus.filter'
import DateRelativeFilter from './filters/dateRelative.filter'
import UserAgentFilter from './filters/userAgent.filter'
import TicketTypeFilter from './filters/ticketType.filter'
import TicketStatusFilter from './filters/ticketStatus.filter'
import CapitalizeFilter from './filters/capitalize.filter'
import PercentageFilter from './filters/percentage.filter'
import TicketOriginFilter from './filters/ticketOrigin.filter'
import PaymentMethodFilter from './filters/paymentMethod.filter'

// Fonts
// import './assets/fonts/roboto-v18-latin/roboto.scss'

// Styles
import './assets/css/main.scss'

// Icons
import 'vue-awesome/icons/map-marker'
import 'vue-awesome/icons/calendar'
import 'vue-awesome/icons/calendar-check'
import 'vue-awesome/icons/music'
import 'vue-awesome/icons/coins'
import 'vue-awesome/icons/clone'
import 'vue-awesome/icons/ellipsis-v'
import 'vue-awesome/icons/ban'
import 'vue-awesome/icons/robot'
import 'vue-awesome/icons/sticky-note'
import 'vue-awesome/icons/ticket-alt'
import 'vue-awesome/icons/sync'
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/hashtag'
import 'vue-awesome/icons/tags'
import 'vue-awesome/icons/chevron-up'
import 'vue-awesome/icons/chevron-down'
import 'vue-awesome/icons/chevron-right'
import 'vue-awesome/icons/unlock'
import 'vue-awesome/icons/asterisk'
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/check-circle'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/times-circle'
import 'vue-awesome/icons/spinner'
import 'vue-awesome/icons/share-alt-square'
import 'vue-awesome/icons/share'
import 'vue-awesome/icons/trash'
import 'vue-awesome/icons/exclamation-triangle'
import 'vue-awesome/icons/info-circle'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/minus'
import 'vue-awesome/icons/list'
import 'vue-awesome/icons/flag'
import 'vue-awesome/icons/power-off'
import 'vue-awesome/icons/plug'
import 'vue-awesome/icons/search'
import 'vue-awesome/icons/arrow-up'
import 'vue-awesome/icons/arrow-down'
import 'vue-awesome/icons/arrow-right'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/users'
import 'vue-awesome/icons/book'
import 'vue-awesome/icons/print'
import 'vue-awesome/icons/qrcode'
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/eye-slash'
import 'vue-awesome/icons/link'
import 'vue-awesome/icons/shopping-cart'
import 'vue-awesome/icons/shopping-bag'
import 'vue-awesome/icons/question'
import 'vue-awesome/icons/edit'
import 'vue-awesome/icons/pen-fancy'
import 'vue-awesome/icons/clone'
import 'vue-awesome/icons/file-invoice'
import 'vue-awesome/icons/file-pdf'
import 'vue-awesome/icons/file-contract'
import 'vue-awesome/icons/store'
import 'vue-awesome/icons/copy'
import 'vue-awesome/icons/arrow-left'
import 'vue-awesome/icons/cash-register'
import 'vue-awesome/icons/cog'
import 'vue-awesome/icons/bars'
import 'vue-awesome/icons/external-link-alt'
import 'vue-awesome/icons/tools'
import 'vue-awesome/icons/history'
import 'vue-awesome/icons/wrench'
import 'vue-awesome/icons/desktop'
import 'vue-awesome/icons/key'
import 'vue-awesome/icons/tasks'
import 'vue-awesome/icons/comments'
import 'vue-awesome/icons/mobile-alt'
import 'vue-awesome/icons/chart-bar'
import 'vue-awesome/icons/chart-area'
import 'vue-awesome/icons/download'
import 'vue-awesome/icons/video'
import 'vue-awesome/icons/door-open'
import 'vue-awesome/icons/door-closed'
import 'vue-awesome/icons/house-user'
import 'vue-awesome/icons/exchange-alt'
import 'vue-awesome/icons/user-shield'
import 'vue-awesome/icons/table'
import 'vue-awesome/icons/clock'
import 'vue-awesome/icons/image'
import 'vue-awesome/icons/save'
import 'vue-awesome/icons/external-link-alt'

import Icon from 'vue-awesome/components/Icon'

moment.locale('pt-BR')
numeral.locale('pt-br')

Vue.component('icon', Icon)

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(VueWait)
Vue.use(BootstrapVue)

Vue.use(VueMask, {
  placeholders: {
    h: /[a-f0-9]/,
  }
})

Vue.use(VueSession, {
  persist: true
})

Vue.use(VueReCaptcha, {
  siteKey: '6LdUrecUAAAAAA--S_ea5JoEubZL1xShzQJbXtBQ',
  loaderOptions: {
    autoHideBadge: true
  }
})

Vue.http.interceptors.push(LoaderMw)
Vue.http.interceptors.push(AuthMw)

Vue.use(VCalendar)

Object.defineProperty(Vue.prototype, '$timetrack', {value: Timetrack})
Object.defineProperty(Vue.prototype, '$_', {value: _})
Object.defineProperty(Vue.prototype, '$moment', {value: moment})
Object.defineProperty(Vue.prototype, '$numeral', {value: numeral})

Vue.filter('date', DateFilter(moment).filter)
Vue.filter('currency', CurrencyFilter(numeral).filter)
Vue.filter('number', NumberFilter(numeral).filter)
Vue.filter('secToHms', SecToHmsFilter(moment).filter)
Vue.filter('orderStatus', OrderStatusFilter().filter)
Vue.filter('dateRelative', DateRelativeFilter(moment).filter)
Vue.filter('userAgent', UserAgentFilter(uaparser).filter)
Vue.filter('ticketType', TicketTypeFilter().filter)
Vue.filter('ticketStatus', TicketStatusFilter().filter)
Vue.filter('capitalize', CapitalizeFilter().filter)
Vue.filter('percentage', PercentageFilter(numeral).filter)
Vue.filter('ticketOrigin', TicketOriginFilter().filter)
Vue.filter('paymentMethod', PaymentMethodFilter().filter)

new Vue({
  router,
  render: h => h(App),
  wait: new VueWait()
}).$mount('#app')
